import { formatReadableDate } from '../queries';

export const getDefaultValues = (jobData) => {
  if (!jobData) return {};
  return Object.entries(jobData).reduce((acc, [key, value]) => {
    if (['receivedDate', 'availableTill'].includes(key)) {
      value = formatReadableDate(value);
    }
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = { value, code: key };
    }
    return acc;
  }, {});
};
